import { UI_WEEK_CHANGE, UI_DAY_CHANGE } from "../actions";
import { Action } from "../actions";
import { getTodayDate, getMonday } from "../utils/date";

export const weekVisibleReducer = (
    state: string = getMonday(getTodayDate()),
    action: Action,
): string => {
    switch (action.type) {
        case UI_WEEK_CHANGE:
            return action.payload;
        case UI_DAY_CHANGE:
            return getMonday(action.payload.date);
        default:
            return state;
    }
};
